import { useEffect, useState } from "react";
import Layout from "./Layout";
import {
  server_post_data,
  fetch_points,
  update_point_status,
  delete_point,
} from "../ServiceConnection/serviceconnection";
import { handleError, handleSuccessShow } from "../CommonJquery/CommonJquery";
import Loader from "./Loader.js";

const ViewUpdates = () => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUpdate, setSelectedUpdate] = useState(null);
  const [poitsData, setPointsData] = useState([]);
  const [updateForm, setUpdateForm] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const master_data_get = async () => {
    setIsLoading(true);
    let fd = new FormData();

    await server_post_data(fetch_points, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          setPointsData(Response.data.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const handleUpdateStatus = (update) => {
    setSelectedUpdate(update);
    setShowUpdateModal(true);
  };

  const handleDeleteConfirmation = (update) => {
    setSelectedUpdate(update);
    setShowDeleteModal(true);
  };

  const handleSubmitUpdate = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let fd = new FormData();
    fd.append("primary_id", selectedUpdate.primary_id);
    fd.append("status", updateForm.status);

    await server_post_data(update_point_status, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          handleSuccessShow(Response.data.message);
          setIsLoading(false);
          setShowUpdateModal(false);
          setSelectedUpdate(null);
          master_data_get();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleConfirmDelete = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let fd = new FormData();
    fd.append("primary_id", selectedUpdate.primary_id);

    await server_post_data(delete_point, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          handleSuccessShow(Response.data.message);
          setIsLoading(false);
          setShowDeleteModal(false);
          setSelectedUpdate(null);
          master_data_get();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="page">
          <h2 className="page-title">View & Manage Updates</h2>

          <div className="table-container1">
            <table className="table">
              <thead>
                <tr className="table-header">
                  <th className="th">Sr.No.</th>
                  <th className="th">Type</th>
                  <th className="th">Name</th>
                  <th className="th">Status</th>
                  <th className="th">Timestamp</th>
                  <th className="th">Action</th>
                </tr>
              </thead>
              <tbody>
                {poitsData &&
                  poitsData.length > 0 &&
                  poitsData.map((update, index) => (
                    <tr key={update.id} className="table-row">
                      <td className="td">{index + 1}</td>
                      <td className="td">
                        <span className="type-badge general">
                          {update.type}
                        </span>
                      </td>
                      <td className="td">{update.point_name}</td>
                      <td className="td">
                        <span
                          className={`status-badge ${
                            parseInt(update.status) === 0
                              ? "active"
                              : parseInt(update.status) === 1
                              ? "closed"
                              : "maintanance"
                          }`}
                        >
                          {parseInt(update.status) === 0
                            ? "Active"
                            : parseInt(update.status) === 1
                            ? "Closed"
                            : "Under Maintanance"}
                        </span>
                      </td>
                      <td className="td">
                        {update.start_time} - {update.end_time}
                      </td>
                      <td className="td">
                        <div className="btns-container">
                          <button
                            className="update-button"
                            onClick={() => handleUpdateStatus(update)}
                          >
                            Update Status
                          </button>
                          <button
                            className="delete-button"
                            onClick={() => handleDeleteConfirmation(update)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            {poitsData?.length === 0 && (
              <div className="empty-state">
                <p>
                  No updates available. Add some updates from the Live Updates
                  section.
                </p>
              </div>
            )}
          </div>

          {/* Update Modal */}
          {showUpdateModal && selectedUpdate && (
            <div
              className="modal-overlay"
              onClick={() => setShowUpdateModal(false)}
            >
              <div className="modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h3>Update {selectedUpdate.type} Status</h3>
                  <button
                    className="close-button"
                    onClick={() => setShowUpdateModal(false)}
                  >
                    ×
                  </button>
                </div>
                <form onSubmit={handleSubmitUpdate}>
                  <div className="modal-content">
                    {/* Name (non-editable) */}
                    <div className="form-group">
                      <label className="label">Name:</label>
                      <input
                        type="text"
                        className="input"
                        value={selectedUpdate.point_name}
                        disabled
                      />
                    </div>

                    {/* Status (editable) */}
                    <div className="form-group">
                      <label className="label">Status:</label>
                      <select
                        className="select"
                        value={updateForm.status}
                        onChange={(e) =>
                          setUpdateForm({
                            ...updateForm,
                            status: e.target.value,
                          })
                        }
                      >
                        <option value="0">Open</option>
                        <option value="1">Closed</option>
                        <option value="2">Under Maintanance</option>
                      </select>
                    </div>
                  </div>
                  <div className="modal-actions">
                    <button type="submit" className="modal-button">
                      Save Changes
                    </button>
                    <button
                      type="button"
                      className="modal-button secondary"
                      onClick={() => setShowUpdateModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Delete Confirm Modal */}
          {showDeleteModal && selectedUpdate && (
            <div
              className="modal-overlay"
              onClick={() => setShowDeleteModal(false)}
            >
              <div className="modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h3>Confirm Delete</h3>
                  <button
                    className="close-button"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    ×
                  </button>
                </div>
                <div className="modal-content">
                  <p>Are you sure you want to delete this point?</p>
                  <div className="form-group">
                    <label className="label">Name:</label>
                    <input
                      type="text"
                      className="input"
                      value={selectedUpdate.point_name}
                      disabled
                    />
                  </div>
                </div>
                <div className="modal-actions">
                  <button
                    type="button"
                    className="modal-button"
                    onClick={handleConfirmDelete}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="modal-button secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Layout>
    </>
  );
};

export default ViewUpdates;
